export const useNameInitials = () => {
  const translateInitials = (name?: string | undefined) => {
    if (!name || name.length === 0) {
      return '';
    }

    if (!name.includes(' ')) {
      return name.trim().substring(0, 1).toUpperCase();
    }

    return name
      .trim()
      .split(' ')
      .slice(0, 2)
      .map(str => (str ? str[0].toUpperCase() : ''))
      .join('');
  };

  return { translateInitials };
};
